import { Route, Routes } from "react-router-dom";

import { ROLES } from "./config/roles";
import Register from "./features/Auth/Register";
import RequireAuth from "./features/Auth/RequireUser";
import Layout from "./layouts/Layout";
// import { Dashboard } from "./pages/Dashboard";
import IndexPage from "./pages/index";
import "./styles/globals.css";
import Admin from "./pages/Admin";
import Setting from "./features/Setting/Setting";
import ForgotPassword from "./pages/ForgotPassword";

import Analytics from "@/pages/Analytics";
import Overview from "@/pages/Overview.tsx";
import PedigreeProfile from "@/features/Charts/Pedigree.Profile.tsx";
import Search from "@/pages/Search.tsx";
import AnimalProfile from "@/features/Animals/Animal.Profile.tsx";
import PageNotFound from "@/pages/404.tsx";
import ResetForm from "@/components/ResetForm.tsx";
import { AnimalBrowser } from "@/pages/Find.Animal.tsx";
import { Home } from "@/pages/Profile.tsx";
import AddSilaHome from "@/pages/Admin-Add-Animal.tsx";
import { AnimalGridPage } from "@/pages/Animal-Grid-Page.tsx";
import { RecipientForm } from "@/pages/RecipientForm.tsx";
import GuestDashboardPage from "@/pages/Guest-Page.tsx";
import { AnimalDetailPage } from "@/pages/animal-detialed-page.tsx";
import ReproductiveProcessDashboard from "@/pages/Reproductive-Process-Dashboard.tsx";
import MemoizedSupervisorDashboard from "@/features/Supervisor/Supervisor.Dashboard.tsx";
import { ReproductiveProcess } from "./features/Animals/reproductiveProcess";
import { AnimalProfilePage } from "@/features/Animals/Animal.Profile.Page.tsx";
import AnimalProfileUpdateForm from "@/features/Animals/UpdateSilaAnimals.tsx";
import AuthPage from "./pages/Auth.Page";
import FarmerAnimalsForm from "@/features/Farmers/Farmer-Animals-Form.tsx";
import AnimalForm from "./features/Form/AnimalForm";
import AnimalVerificationPage from "@/pages/AnimalVerificationPage";
import CertificateValidator from "@/pages/CertificateValidator";
import PublicVerifier from "@/pages/PublicVerifier";

// import LandingPage from "@/pages/LandingPage.tsx"

function App() {
  return (
    <>
      <Routes>
        <Route element={<PageNotFound />} path={"*"} />
        {/* <Route element={ <Banner /> } path={ "/hello" } /> */}
        {/* <Route element={<AuthPage />} path={"/example"} /> */}
        {/* <Route element={<MainLandingPage />} path={"/home"} /> */}
        <Route
          element={<AnimalBrowser key={location.pathname} />}
          path={"/Search-Animal"}
        />
        <Route element={<AnimalGridPage />} path={"/Search-Results"} />
        <Route
          element={<Home key={location.pathname} />}
          path={"/Browse-Animal/:id"}
        />
        <Route element={<Layout />} path="/">
          {/* <Route
						 element={<LandingPage />}
						 path={"/landing"}
						 /> */}

          <Route element={<IndexPage />} path="/" />
          <Route element={<AuthPage />} path="/login" />
          <Route element={<ForgotPassword />} path="/forgotPassword" />
          <Route element={<ResetForm />} path="/resetPassword/:resetToken" />

          <Route element={<Register />} path="/register" />
          <Route path="/look-up/">
            <Route index element={<Search />} />
            <Route element={<AnimalProfile />} path=":id" />
          </Route>

          <Route element={<GuestDashboardPage />} path={"/guest/dashboard"} />
          <Route element={<AnimalDetailPage />} path={"/animals/:id"} />
          <Route
            element={<AnimalVerificationPage />}
            path="/verify/animal/:id"
          />
          <Route element={<CertificateValidator />} path="/verify/document" />
          <Route element={<PublicVerifier />} path="/verify" />

          {/* Protected Routes */}
          {/* <Route element={<PersistLogin />}> */}
          <Route
            element={
              <RequireAuth
                allowedRoles={[
                  ROLES.supervisor,
                  ROLES.farmer,
                  "Farmer",
                  ROLES.admin,
                ]}
              />
            }
          >
            <Route
              element={<RequireAuth allowedRoles={[ROLES.farmer, "Farmer"]} />}
            >
              {/* <Route element={<Main />} path="/home" /> */}
              <Route element={<Overview />} path="/overview" />
              <Route element={<FarmerAnimalsForm />} path="/add-animal" />
            </Route>
            <Route
              element={
                <RequireAuth
                  allowedRoles={[ROLES.supervisor || "Supervisor"]}
                />
              }
            >
              {/* <Route element={<Dashboard />} path="/dashboard" /> */}
              <Route
                element={<MemoizedSupervisorDashboard />}
                path="/supervisor/dashboard"
              />
            </Route>
            <Route element={<RequireAuth allowedRoles={[ROLES.admin]} />}>
              <Route element={<Admin />} path="/admin" />

              <Route element={<PedigreeProfile />} path="/export-to-pdf/:id" />
              <Route
                element={<AnimalProfilePage />}
                path="/farmers-animals/animal/profile/:id"
              />
              <Route
                element={<AnimalForm />}
                path="/admin/register-farmer-animal"
              />
              <Route
                element={<AddSilaHome />}
                path={"/admin/admin-add-Animal"}
              />
              <Route
                element={<RecipientForm />}
                path={"/admin/recipient-analysis-form/:id"}
              />
              <Route element={<Analytics />} path="/analytics" />
              <Route
                element={<ReproductiveProcess />}
                path={"/admin/animals/:id"}
              />
              <Route
                element={<ReproductiveProcessDashboard />}
                path={"/admin/animals/reproductiveList"}
              />

              <Route
                element={<ReproductiveProcessDashboard />}
                path={"/admin/farmer/animals/animal/reproductiveList"}
              />

              <Route
                element={<AnimalProfileUpdateForm />}
                path={"/admin/sila-owned-animals/updating/:id"}
              />
            </Route>
            <Route element={<Setting />} path="/settings" />
          </Route>
        </Route>
      </Routes>
    </>
  );
}

export default App;
